<template>
  <the-new-header></the-new-header>

  <section class="search-section">
    <base-info-bar>
      <router-link to="/search-page" style="color: black;">{{ searchTitle }}</router-link>
    </base-info-bar>
    <SearchContent :keyword="inputValue" :title="searchTitle"></SearchContent>
  </section>

  <the-footer></the-footer>
</template>

<script>
import SearchContent from '@/components/search-page/SearchContent.vue'
export default {
  components: {
    SearchContent
  },
  computed: {
    searchTitle () {
      if (this.$store.state.lang === 'vn') return 'Tìm kiếm'
      else return 'Search'
    },
    inputValue () {
      // Access the query parameter
      return this.$route.query.input
    }
  },
  async created () {
    // this.isLoading = false
    // await this.$store.dispatch('news/getNewsData')
    await this.$store.dispatch('recruit/getAdmissionsByFilter', { filterQuery: this.$route.query.input.toLowerCase() })
    await this.$store.dispatch('news/getNewsByFilters', { filterQuery: this.$route.query.input.toLowerCase() })
    await this.$store.dispatch('services/getTSByFilter', { filterQuery: this.$route.query.input.toLowerCase() })
    const data = this.$store.getters['services/getFrontendTS'].filter(item => item.subMenus === true).map(item => item.id)
    if (data) {
      await this.$store.dispatch('services/getTSDetailForPages', { ids: data })
    }
    // this.isLoading = true
  }
}
</script>

<style scoped>
.search-section {
  padding: 0 170px;
  min-height: 525px;
}

.search-section a {
  text-decoration: none;
  color: rgb(28, 108, 193);
  font-weight: 700;
}

.search-section span{
  font-weight: 800;
}

  @media (max-width: 1356px) {
    .search-section {
      padding: 0 100px;
    }
  }

  @media (max-width: 1080px) {
    .search-section {
      padding: 0 50px;
    }
  }

  @media (max-width: 720px) {
    .search-section {
      padding: 0px 20px;
    }
  }
</style>
